/*
 * girlcave — Product Overview "load more" (sections/gc-product-grid.liquid).
 *
 * The control ships as a plain <a href> to the next paginated page and works
 * with this file absent or blocked. This upgrades it to append in place via
 * the Section Rendering API, which returns just the grid because the page
 * chrome is rendered by layout/theme.liquid rather than by the section.
 *
 * The address bar is deliberately left alone. Rewriting it to ?page=N would
 * make a reload or a shared link open page N on its own, silently dropping
 * every product above it — the opposite of what the reader just did.
 */
if (!customElements.get('gc-product-grid')) {
  customElements.define(
    'gc-product-grid',
    class GcProductGrid extends HTMLElement {
      connectedCallback() {
        this.grid = this.querySelector('[data-gc-grid]');
        this.onClick = this.onClick.bind(this);
        this.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.controller?.abort();
      }

      onClick(event) {
        const link = event.target.closest('[data-gc-more-link]');
        if (!link || !this.contains(link) || this.busy) return;
        event.preventDefault();
        this.load(link.href);
      }

      async load(href) {
        const wrap = this.querySelector('[data-gc-more]');
        if (!wrap || !this.grid) return;

        this.busy = true;
        wrap.setAttribute('aria-busy', 'true');
        this.controller?.abort();
        this.controller = new AbortController();

        const separator = href.includes('?') ? '&' : '?';
        const url = `${href}${separator}section_id=${this.dataset.section}`;

        try {
          const response = await fetch(url, { signal: this.controller.signal });
          if (!response.ok) throw new Error(response.status);

          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const nextGrid = doc.querySelector('[data-gc-grid]');
          if (!nextGrid) throw new Error('no grid in response');

          const added = Array.from(nextGrid.children);
          added.forEach((card) => this.grid.appendChild(card));

          const nextLink = doc.querySelector('[data-gc-more-link]');
          if (nextLink) {
            wrap.querySelector('[data-gc-more-link]').href = nextLink.href;
          } else {
            wrap.remove();
          }

          // Keyboard and screen-reader users land on the first new card
          // rather than being dropped back at the top of the document.
          const first = added[0];
          if (first) {
            first.setAttribute('tabindex', '-1');
            first.focus({ preventScroll: true });
          }
        } catch (error) {
          if (error.name === 'AbortError') return;
          // Fall back to the navigation the link would have done anyway.
          window.location.href = href;
        } finally {
          this.busy = false;
          wrap.removeAttribute('aria-busy');
        }
      }
    }
  );
}
